export default {
  drawRect (ctx, x, y, w, h, r, fill, stroke, strokeWidth) {
    if (w < 2 * r) r = w / 2
    if (h < 2 * r) r = h / 2

    const rect = new Path2D()
    rect.moveTo(x + r, y)
    rect.arcTo(x + w, y, x + w, y + h, r)
    rect.arcTo(x + w, y + h, x, y + h, r)
    rect.arcTo(x, y + h, x, y, r)
    rect.arcTo(x, y, x + w, y, r)
    rect.closePath()

    ctx.fillStyle = fill
    ctx.fill(rect)

    ctx.lineWidth = strokeWidth
    ctx.strokeStyle = stroke
    ctx.stroke(rect)

    return rect
  },
  drawRectWithShadow (ctx, x, y, w, h, r, fill, stroke, strokeWidth, shadow, shadowSize) {
    if (w < 2 * r) r = w / 2
    if (h < 2 * r) r = h / 2

    const rect = new Path2D()
    rect.moveTo(x + r, y)
    rect.arcTo(x + w, y, x + w, y + h, r)
    rect.arcTo(x + w, y + h, x, y + h, r)
    rect.arcTo(x, y + h, x, y, r)
    rect.arcTo(x, y, x + w, y, r)
    rect.closePath()

    ctx.shadowColor = shadow
    ctx.shadowBlur = shadowSize
    ctx.fillStyle = fill
    ctx.fill(rect)

    ctx.shadowColor = 'black'
    ctx.shadowBlur = 0

    ctx.lineWidth = strokeWidth
    ctx.strokeStyle = stroke
    ctx.stroke(rect)

    return rect
  },
  drawCircle (ctx, x, y, r, fill, stroke, strokeWidth) {
    const circle = new Path2D()
    circle.arc(x, y, r, 0, 2 * Math.PI)
    circle.closePath()

    ctx.fillStyle = fill
    ctx.fill(circle)

    ctx.lineWidth = strokeWidth
    ctx.strokeStyle = stroke
    ctx.stroke(circle)

    return circle
  },

  // Draws the given text centered at x, y (no line splitting)
  drawText (ctx, text, x, y, font, fill, clipPath) {
    ctx.font = font
    ctx.fillStyle = fill

    ctx.save()
    if (clipPath !== undefined) {
      ctx.clip(clipPath)
    }

    const textMetrics = ctx.measureText(text)
    ctx.fillText(text, x - textMetrics.width / 2, y + textMetrics.actualBoundingBoxAscent / 2)

    ctx.restore()
  },

  // Draws the given text centered in x but starting at y with line splitting
  drawTextMultiline (ctx, text, x, y, font, fill, width, lineSpacing, clipPath) {
    ctx.font = font

    ctx.save()
    if (clipPath !== undefined) {
      ctx.clip(clipPath)
    }

    const lines = []
    let currIndex = 0
    while (true) {
      const nextSpace = text.indexOf(' ', currIndex)
      const isEnd = nextSpace === -1
      const substr = isEnd ? text.substring(currIndex, text.length) : text.substring(currIndex, nextSpace)

      if (lines.length === 0) {
        lines.push(substr)
      } else {
        const newLine = lines[lines.length - 1] + ' ' + substr
        if (ctx.measureText(newLine).width > width) {
          lines.push(substr)
        } else {
          lines[lines.length - 1] = newLine
        }
      }

      if (!isEnd) { currIndex = nextSpace + 1 }
      if (isEnd) break
    }

    ctx.fillStyle = fill

    let currY = y
    lines.forEach((line) => {
      const lineMetrics = ctx.measureText(line)

      currY += lineMetrics.actualBoundingBoxAscent
      ctx.fillText(line, x - lineMetrics.width / 2, currY)
      currY += lineMetrics.actualBoundingBoxDescent + lineSpacing
    })

    ctx.restore()
  },

  // Gets the mininum width of the text if allowing for line splitting (so widest word)
  getTextMinWidth (ctx, text, font) {
    ctx.font = font

    let result = 0
    let currIndex = 0
    while (true) {
      const nextSpace = text.indexOf(' ', currIndex)
      const isEnd = nextSpace === -1
      const substr = isEnd ? text.substring(currIndex, text.length) : text.substring(currIndex, nextSpace)
      const strWidth = ctx.measureText(substr).width

      if (strWidth > result) {
        result = strWidth
      }

      if (!isEnd) { currIndex = nextSpace + 1 }
      if (isEnd) break
    }

    return result
  },

  // Gets minimum height of the text given a width
  getTextMinHeight (ctx, text, font, width, lineSpacing) {
    ctx.font = font

    const lines = []
    let currIndex = 0
    while (true) {
      const nextSpace = text.indexOf(' ', currIndex)
      const isEnd = nextSpace === -1
      const substr = isEnd ? text.substring(currIndex, text.length) : text.substring(currIndex, nextSpace)

      if (lines.length === 0) {
        lines.push(substr)
      } else {
        const newLine = lines[lines.length - 1] + ' ' + substr
        if (ctx.measureText(newLine).width > width) {
          lines.push(substr)
        } else {
          lines[lines.length - 1] = newLine
        }
      }

      if (!isEnd) { currIndex = nextSpace + 1 }
      if (isEnd) break
    }

    let totalHeight = (lines.length - 1) * lineSpacing
    lines.forEach((line) => {
      const lineMetrics = ctx.measureText(line)
      totalHeight += lineMetrics.actualBoundingBoxAscent + lineMetrics.actualBoundingBoxDescent
    })

    return totalHeight
  }
}
